<template>
  <div style="position: relative">
    <button @click="show" :aria-label="$t('buttons.new')" :title="$t('buttons.new')" class="action" id="new-button" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
      <plus-circle-icon size="1.5x" class="custom-class"></plus-circle-icon>
      <span>{{ $t('buttons.new') }}</span>
    </button>
    <nav id="menu-new" :style="menuStyle">
      <div style="display: block">
        <new-folder-button></new-folder-button>
        <new-file-button></new-file-button>
        <new-doc-button></new-doc-button>
        <new-sheet-button></new-sheet-button>
      </div>
    </nav>
  </div>  
</template>

<script>
import { PlusCircleIcon } from 'vue-feather-icons';
import NewFileButton from './NewFile.vue';
import NewFolderButton from './NewFolder.vue';
import NewSheetButton from './NewSheet.vue';
import NewDocButton from './NewDoc.vue';
import { mapMutations, mapState } from 'vuex';

export default {
  name: 'new-button',
  data: function () {
    return {
      isShow: false,
      isButton: false
    };
  },
  components: {
    PlusCircleIcon,
    NewFileButton,
    NewFolderButton,
    NewSheetButton,
    NewDocButton
  },
  computed: {
    ...mapState(['selected']),
    menuStyle () {
      if (this.isShow) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    }
  },
  mounted() {
    window.addEventListener('click', this.click);
  },
  beforeDestroy () {
    window.removeEventListener('click', this.click);
  },
  methods: {
    ...mapMutations(['resetSelected']),
    click() {
      if (!this.isButton && this.isShow) {
        this.isShow = !this.isShow;
      }
    },
    mouseEnter() {
      this.isButton = true;
    },
    mouseLeave() {
      this.isButton = false;
    },
    show() {
      if (this.selected.length > 0) {
        this.resetSelected();
      }
      this.isShow = !this.isShow;
    }
  }
};
</script>
